import React from 'react';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ThankYou: React.FC = () => {
  return (
    <div className="marketing-shell min-h-[70vh] bg-[#dceee9] flex items-center justify-center px-4 pt-28 pb-20">
      <div className="text-center max-w-md">
        <CheckCircle size={64} className="text-[#087064] mx-auto mb-6" />
        <h1 className="text-3xl font-black text-[#10232d] mb-4">
          ¡Gracias por contactarnos!
        </h1>
        <p className="text-[#536970] mb-8">
          Hemos recibido tu mensaje. Te contactaremos en menos de 24 horas.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-[#087064] text-white font-bold rounded-full hover:bg-[#065d54] transition-colors shadow-[0_12px_36px_rgba(8,112,100,0.24)]"
        >
          <ArrowLeft size={18} />
          Volver al inicio
        </Link>
      </div>
    </div>
  );
};
